import React from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import helpers from '../lib/helpers';
import styles from '../styles/variables.scss';

export default function RoleMenu() {
  function SignUpAndApplyDesktop() {
    return (
      <div id="signup-apply-desktop">
        <Col xs={12} md={6} className="no-padding-left">
          <Link to="/signup/driver">
            <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
              I'm a Driver
            </Button>
          </Link>
        </Col>
        <Col xs={12} md={6} className="no-padding-right">
          <Link to="/signup/team-member">
            <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
              I'm a Team Member
            </Button>
          </Link>
        </Col>
      </div>
    );
  }

  function SignUpAndApplyMobile() {
    return (
      <Col xs={12} id="/signup-apply-mobile">
        <h6 id="sign-up-mobile-message" className="text-center">
          This form is designed for use in a Browser. Please try signing up from there.
        </h6>
      </Col>
    );
  }

  function SignUpAndApplySection() {
    return (helpers.isMobile()) ? <SignUpAndApplyMobile /> : <SignUpAndApplyDesktop />;
  }

  return (
    <React.Fragment>
      <Grid id="role-selection-grid" fluid>
        <Row id="role-selection-row">
          <Col xs={10} xsOffset={1} className="role-selection-col">
            <Col className="role-title" md={12}>Sign-up and Apply</Col>
            <SignUpAndApplySection />
          </Col>

          <Col xs={10} xsOffset={1} className="role-selection-col">
            <Col className="role-title" md={12}>Submit Ratings</Col>

            <Col xs={12} md={6} className="no-padding-left">
              <Link to="/rating/self">
                <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
                  Rate Myself
                </Button>
              </Link>
            </Col>
            <Col xs={12} md={6} className="no-padding-right">
              <Link to="/rating/driver/">
                <Button className="col-xs-12 col-md-12 col-lg-12 role-button">
                  Rate a Driver
                </Button>
              </Link>
            </Col>
          </Col>
        </Row>

      </Grid>
      <style jsx global>{`
        #sign-up-mobile-message {
          color: ${styles.offwhite};
        }

        .role-selection-col {
          margin-bottom: 40px;
        }
      `}</style>
    </React.Fragment>
  );
}
